import Frame from "Components/Frame/";
import waitbar from "Media/waitbar.gif";

const PleaseWait = () => {
    return(<Frame><img src = {waitbar} /></Frame>)
}

export default PleaseWait;